export default __webpack_public_path__ + "static/media/hideDark.68a4b658.svg";